import { IconButton, Row, Tooltip } from 'components/Blocks';
import { AlertCircleIcon, CheckIcon } from 'components/Blocks/Icons';
import { EmailConfirm } from 'components/EmailConfirmation';

import { useLang } from 'locale';
import { useUser } from 'providers/Auth';

export function UserEmail() {
  const { t } = useLang();

  const { email, emailConfirmed } = useUser();

  return (
    <Row gap="2">
      {emailConfirmed ? (
        <Tooltip content={t('verified')} ensurePresence>
          <CheckIcon color="success" />
        </Tooltip>
      ) : (
        <EmailConfirm
          reason="INCENTIVE"
          trigger={
            <IconButton tooltipContent={t('confirm-your-email')}>
              <AlertCircleIcon size={14} color="destructive" />
            </IconButton>
          }
        />
      )}

      <span>{email}</span>
    </Row>
  );
}
